module.exports = __webpack_public_path__ + "static/media/offline-support.f3911273.svg";